export function buildUsersFilter(options) {
    const { key, items } = options;
    if (!items || !items.length) {
        return undefined;
    }
    return { [key]: { _in: items } };
}
